import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mc0097',
    ecrans: ['00-2']
});
